<template>
  <p class="clearfix mb-0">
    
    <span class="float-md-left d-block d-md-inline-block mt-25">
      <a  target="_blank" :href="pdfLink">Kullanım Dokümanı</a> | 
      <strong>Tel: </strong>{{ $param('company.phone') }} | 
      <strong>Adres: </strong>{{ $param('company.address') }} |
      Copyright© {{ new Date().getFullYear() }} - Sedbim | 
      <span class="d-none d-sm-inline-block"> Tüm hakları saklıdır. |</span>
      <a :href="$param('company.website.url')"> {{ $param('company.website.url') }}</a>
    </span>
  </p>
</template>

<script>
import { BLink } from 'bootstrap-vue'

export default {
  components: {
    BLink,
  },
  data () {
  return {
   pdfLink: 'usage-document.pdf',
  }
}
}
</script>
